import { render } from "./kalio-calendly-office-hour.vue?vue&type=template&id=3c91e97a"
import script from "./kalio-calendly-office-hour.vue?vue&type=script&lang=js"
export * from "./kalio-calendly-office-hour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__